import { __ } from '@wordpress/i18n';
import { Modal } from '@wordpress/components';

const ProModal = ({ proModalOpen, setProModalOpen }) => {

    return (
        <>
            {proModalOpen && (
                <Modal className='ttpProModal' title={__('Pro Feature', 'slider')} onRequestClose={() => setProModalOpen(false)}>

                    <div className='ttpProFeature'>
                        <h3>{__('Unlock B Slider Feature', 'slider')}</h3>

                        <a target="_blank" rel="noreferrer" href="https://bplugins.com/products/b-slider/#pricing">{__('Upgrade to Pro', 'slider')}</a>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default ProModal;